import { CONFIGURATION } from './types';

const initialState = {};

const ACTION_HANDLERS = {
    [CONFIGURATION.LOAD_WIDGET]: (action) => ({
        widget: action.data
    }),
    [CONFIGURATION.LOAD_POPUP]: (action) => ({ popup: action.data }),
    [CONFIGURATION.LOAD_EIP]: (action) => ({ eip: action.data }),
    [CONFIGURATION.UPDATE_WIDGET]: (action, state) => ({
        widget: {
            ...state.widget,
            ...action.data
        }
    }),
    [CONFIGURATION.RESET]: () => initialState,
    [CONFIGURATION.RESET_WIDGET]: () => ({ widget: null }),
    [CONFIGURATION.RESET_POPUP]: () => ({ popup: null }),
    [CONFIGURATION.RESET_EIP]: () => ({ eip: null })
};

const reducer = (state = initialState, action = { type: null }) => {
    const actionHandler = ACTION_HANDLERS[action.type];
    if (actionHandler) {
        return {
            ...state,
            ...actionHandler(action, state)
        };
    } else {
        return state;
    }
};

export default reducer;
